import { render, staticRenderFns } from "./returnVisit2.vue?vue&type=template&id=66802bf6&scoped=true&"
import script from "./returnVisit2.vue?vue&type=script&lang=js&"
export * from "./returnVisit2.vue?vue&type=script&lang=js&"
import style0 from "./returnVisit2.vue?vue&type=style&index=0&id=66802bf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66802bf6",
  null
  
)

export default component.exports